import { TimeSpan, TimeZoneMapping } from 'fitbeat.models';

export class DateRange {
  public static wholeDayInCurrentTimezone(yyyymmdd: string): DateRange {
    const now = new Date(yyyymmdd);
    const start = TimeSpan.createStartOfDayDate(now);
    const end = TimeSpan.createEndOfDayDate(now);
    return new DateRange(start, end);
  }

  public static wholeDayInSpecificTimezone(yyyymmdd: string, timezone: string): DateRange {
    const start = TimeZoneMapping.formattedLocalTimeToDate(`${yyyymmdd} 00:00:00`, timezone);
    const end = TimeZoneMapping.formattedLocalTimeToDate(`${yyyymmdd} 23:59:59`, timezone);
    return new DateRange(start, end);
  }

  public static rangeInSpecificTimezone(from: string, to: string, timezone: string): DateRange {
    const start = TimeZoneMapping.formattedLocalTimeToDate(from, timezone);
    const end = TimeZoneMapping.formattedLocalTimeToDate(to, timezone);
    return new DateRange(start, end);
  }

  constructor(public start: Date, public end: Date) {}

  public isDateInThisRange(date: Date): boolean {
    return date >= this.start && date <= this.end;
  }

  public endsAfter(date: Date) {
    return this.end >= date;
  }

  public describe() {
    return `${this.start.toISOString()} to ${this.end.toISOString()}`;
  }
}
